import { FormsModule } from '@angular/forms';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { ModalBaseModule } from 'NewAngular/features/components/modals/modal-base/modal-base.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class PortfolioOptimizerExportPDFModalModule {
}
PortfolioOptimizerExportPDFModalModule.ɵfac = function PortfolioOptimizerExportPDFModalModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || PortfolioOptimizerExportPDFModalModule)(); };
PortfolioOptimizerExportPDFModalModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: PortfolioOptimizerExportPDFModalModule });
PortfolioOptimizerExportPDFModalModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [HelpModalModule, ModalBaseModule, FormsModule, TooltipModule] });
